import React from 'react'
import PropTypes from 'prop-types'
import map from 'lodash/map'
import { TAB_INDEXES, ACCESSIBILITY_CLASSES, triggerClickOnEnter } from 'shared/helpers/AccessibilityHelper'

const SOCIAL_URLS = {
  linkedin: '',
  twitter: 'https://twitter.com/'
}

const SocialLinks = ({ data }) => {
  const handleClick = (network) => {
    const url = SOCIAL_URLS[network] + data[network]
    window.open(url);
  }

  return (
    <div className="social-links">
      {
        map(Object.keys(SOCIAL_URLS), (network) => {
          if(data[network]) {
            return (
              <span
                key={network}
                className={`icon-${network} ${ACCESSIBILITY_CLASSES.main}`}
                onClick={() => handleClick(network)}
                onKeyDown={triggerClickOnEnter}
                tabIndex={TAB_INDEXES.SocialLink}
                role="button"
                aria-label={`open social media - ${network}`}
              />
            )
          }
        })
      }
    </div>
  )
}

SocialLinks.propTypes = {
  data: PropTypes.object.isRequired
}

export default SocialLinks

